export const getAriaLabel = (layerName: string) => {
  return layerName;
};